import React, {useState} from 'react'
import {useSelector} from 'react-redux'
import {faqSelector} from '../selectors'

function Item(props) {
    const {data, isOpenInitial} = props
    const [isOpen, setIsOpen] = useState(isOpenInitial)

    const toggleAnswer = () => setIsOpen(!isOpen)

    return (
        <div className="faq__item">
            <div className="faq-question" onClick={toggleAnswer}>
                {data.question}
            </div>
            <If condition={isOpen}>
                <div className="faq-answer">{data.answer}</div>
            </If>
        </div>
    )
}

export default function FAQ() {
    const faq = useSelector(faqSelector)

    return (
        <If condition={faq.length}>
            <div className="faq">
                <h2 className="faq__title">FAQ</h2>
                <div className="faq__list">
                    <For each="item" index="i" of={faq}>
                        <Item
                            key={i}
                            data={item}
                            isOpenInitial={i === 0 ? true : false}
                        />
                    </For>
                </div>
            </div>
        </If>
    )
}
